import o, { PureComponent as t } from "react";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var _n = function n(o, t) {
  return (_n = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (o, t) {
    o.__proto__ = t;
  } || function (o, t) {
    for (var n in t) {
      t.hasOwnProperty(n) && (o[n] = t[n]);
    }
  })(o, t);
};

var e = function (t) {
  function e() {
    var o = null !== t && t.apply(this, arguments) || this;
    return o.onBtnClick = function () {
      var t = o.props,
          n = t.throughTalk,
          e = void 0 !== n && n,
          i = t.version,
          r = void 0 === i ? "v2" : i,
          a = t.getProfile,
          c = void 0 !== a && a,
          s = t.onSuccess,
          u = t.onFailure;
      window.Kakao && window.Kakao.Auth.login({
        throughTalk: e,
        success: function success(o) {
          c ? window.Kakao.API.request({
            url: "/" + r + "/user/me",
            success: function success(t) {
              s({
                response: o,
                profile: t
              });
            },
            fail: u
          }) : s({
            response: o
          });
        },
        fail: u
      });
    }, o;
  }

  return function (o, t) {
    function e() {
      this.constructor = o;
    }

    _n(o, t), o.prototype = null === t ? Object.create(t) : (e.prototype = t.prototype, new e());
  }(e, t), e.prototype.componentDidMount = function () {
    var o = this.props.jsKey;
    !function (t, n) {
      if (null == document.getElementById(t)) {
        var e = document.createElement("script");
        e.id = t, e.src = "//developers.kakao.com/sdk/js/kakao.min.js", e.onload = function () {
          window.Kakao.init(o);
        }, document.body.appendChild(e);
      }
    }("kakao-sdk");
  }, e.prototype.render = function () {
    var t = this.props,
        n = t.render,
        i = t.className,
        r = void 0 === i ? "" : i,
        a = t.useDefaultStyle,
        c = void 0 !== a && a,
        s = t.children,
        u = void 0 === s ? null : s,
        l = t.buttonText,
        p = void 0 === l ? "Login with Kakao" : l;
    return "function" == typeof n ? n({
      onClick: this.onBtnClick
    }) : o.createElement("button", {
      type: "button",
      className: r,
      onClick: this.onBtnClick,
      style: c ? e.DEFAULT_STYLE : void 0
    }, u || p);
  }, e.DEFAULT_STYLE = {
    display: "inline-block",
    padding: "0px",
    width: "222px",
    height: "49px",
    lineHeight: "49px",
    color: "rgb(60, 30, 30)",
    backgroundColor: "rgb(255, 235, 0)",
    border: "1px solid transparent",
    borderRadius: "3px",
    fontSize: "16px",
    textAlign: "center"
  }, e;
}(t);

export default e;